"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageTemplateNav = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const StyledPageTemplateNav = styled_components_1.default.div `
  display: flex;
  background: #fff;
  margin: 0 -30px;
  padding: 0 30px;
  &.tabs {
    flex-direction: column;
    padding: 0;
  }
`;
const PageTemplateNav = (_a) => {
    var { tabs, children, className } = _a, props = __rest(_a, ["tabs", "children", "className"]);
    return (react_1.default.createElement(StyledPageTemplateNav, Object.assign({ className: `page-template-nav${className ? ` ${className}` : ''}${tabs ? ' tabs' : ''}` }, props), children));
};
exports.PageTemplateNav = PageTemplateNav;
exports.default = exports.PageTemplateNav;
//# sourceMappingURL=PageTemplateNav.js.map